export default __webpack_public_path__ + "static/media/brand.54bcd0d6.svg";